import { useMutation, useQueryClient } from "@tanstack/react-query";
import { companyApi, companyQueryKeys } from "service/crm/api/company";
import { dealQueryKeys } from "service/crm/api/deal";
import { CreateDealCompanyPayload } from "types/crm/company";
import { DealDetail } from "types/crm/deal";

type CreateDealCompanyVariables = CreateDealCompanyPayload & {
  dealUuid: string;
};


export const useCreateDealCompanyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateDealCompanyVariables): Promise<DealDetail> =>
      companyApi.createCompanyForDeal(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.detail(variables.dealUuid),
      });
      queryClient.invalidateQueries({
        queryKey: companyQueryKeys.byDeal(variables.dealUuid),
      });
      queryClient.invalidateQueries({ queryKey: companyQueryKeys.all });
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.activities(variables.dealUuid),
      });
    },
  });
};
